// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/browser/umd/" + chunkId + "." + {"532":"633ace213f3afd9caf0c","692":"8551cacafd5012e1f291"}[chunkId] + ".js";
};